import { useQuery } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import type { VmAgentLogsResponse } from '@/types/dtos/vm/response/vm-admin.dto';

export const GET_VM_AGENT_LOGS_QUERY_KEY = 'get-vm-agent-logs-admin';

export const useGetVmAgentLogsQuery = (vmId: string | null, limit = 100) => {
  const { getToken } = useAuth();

  return useQuery({
    queryKey: [GET_VM_AGENT_LOGS_QUERY_KEY, vmId, limit],
    queryFn: async () => {
      const token = await getToken();
      return getVmAgentLogs(token ?? '', vmId!, limit);
    },
    enabled: !!vmId,
    retry: false,
    staleTime: 10_000,
    refetchOnWindowFocus: false,
  });
};

const getVmAgentLogs = async (token: string, vmId: string, limit: number): Promise<VmAgentLogsResponse> => {
  const url = `${import.meta.env.VITE_API_URL}/vm/${vmId}/agent-logs?limit=${limit}`;
  return (await sendJSONRequest({ url, method: METHOD.GET, token })) as VmAgentLogsResponse;
};
